import { useRef } from "react";
import { Printer } from "react-feather";
import { useReactToPrint } from "react-to-print";
import { Card, CardHeader } from "reactstrap";
import { H3 } from "../../AbstractElements";
import { CreatedByMe, Href, Print } from "../../Constant";
import CreatedByme from "./CreatedByme";

const ListOfTask = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = useReactToPrint({
    contentRef,
  });

  return (
    <Card className="mb-0">
      <CardHeader className="d-flex">
        <H3 className="mb-0">{CreatedByMe}</H3>
        <a href={Href} onClick={() => handlePrint()}>
          <Printer className="me-2" />
          {Print}
        </a>
      </CardHeader>
      <CreatedByme />
    </Card>
  );
};

export default ListOfTask;
